import { useEffect, useReducer } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

import { ToastType, useToast } from '../../../hooks/useToast'
import { useLinkPartsToCarBulkMutation } from '../../../modules/store/datahubApi/datahubApi'
import { partReducer } from '../../../pages/NewPart/partReducer'
import { Part, PartListSearchParams } from '../../../types/part/partTypes'
import Loader from '../../_atoms/Loader/Loader'
import OverlayWithText from '../../_atoms/OverlayWithText/OverlayWithText'
import PartCreateUpdateTable from '../PartCreateUpdateTable/PartCreateUpdateTable'

import { initialPartState } from './initialPartState'
import styles from './styles.module.scss'

interface IProps {
    parts: Part[]
    isOpen: boolean
    closeModal: () => void
    confirmChanges: () => void
    partListSearchParams?: PartListSearchParams
}

const ModalLinkingToCar = ({ parts, isOpen, closeModal, confirmChanges, partListSearchParams }: IProps) => {
    const [state, dispatch] = useReducer(partReducer, initialPartState)

    const [linkPartsToCarBulk, { isLoading, error, data }] = useLinkPartsToCarBulkMutation()

    const onCloseModal = () => {
        closeModal()
    }

    const confirmChange = async () => {
        const partsId = parts.map(part => part.id)
        const carId = state.fields[0].value
        linkPartsToCarBulk({ carId, partsId, params: partListSearchParams })
    }

    useEffect(() => {
        if (data) {
            closeModal()
            confirmChanges()
        }
    }, [closeModal, confirmChanges, data])

    useToast({ isTriggered: !!error, type: ToastType.ERROR, message: 'Ошибка привязки к автомобилю' })
    useToast({ isTriggered: !!data, type: ToastType.SUCCESS, message: 'Запчасти успешно привязаны' })

    return (
        <>
            <Modal show={isOpen} onHide={onCloseModal} centered dialogClassName={styles.modal}>
                {isLoading && (
                    <OverlayWithText backgroundBootstrapColor={'bg-secondary'}>
                        <Loader diameterInPx={100} thicknessInPx={10} />
                    </OverlayWithText>
                )}
                <Modal.Header closeButton>
                    <Modal.Title>
                        <b>Привязать к автомобилю</b>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <PartCreateUpdateTable dispatch={dispatch} fields={state.fields} />

                        <div className="bg-danger bg-opacity-10 border border-danger text-danger rounded p-3 mt-3 small">
                            При привязке выбранных запчастей к новому автомобилю, информация о старом автомобиле удалится
                        </div>

                        <div className="d-flex justify-content-end mt-3">
                            <Button onClick={confirmChange} disabled={!state.fields[0].value}>
                                Сохранить
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalLinkingToCar
